import { InputGroup, InputLabel, TextInput } from '@components/Common';
import { TrainCarrier } from '@api/queries/inventory';
import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import DetailsInput from './DetailsInput';

interface Props extends WithTranslation {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  train?: TrainCarrier;
  trafficOut: boolean;
  isDisabled?: boolean;
}

const Train = ({ isDisabled, train, onChange, t }: Props) => {
  const { carNumber, billOfLandingNumber, reference } = train || {
    carNumber: '',
    billOfLandingNumber: '',
    reference: ''
  };

  return (
    <>
      <DetailsInput
        name="carNumber"
        label={t('entry.train.car_number')}
        isDisabled={isDisabled}
        value={carNumber}
        onChange={onChange}
      />
      <DetailsInput
        name="billOfLandingNumber"
        label={t('entry.train.bill_of_landing_number')}
        isDisabled={isDisabled}
        value={billOfLandingNumber}
        onChange={onChange}
      />
      <DetailsInput
        name="reference"
        label={t('entry.train.reference')}
        isDisabled={isDisabled}
        value={reference}
        onChange={onChange}
      />
    </>
  );
};

export default withTranslation()(Train);
